



































































































import type { User } from '@/models/user';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { userWebservice } from '@/webservices/user';
import { goToNativeLink } from '@/helpers/routing/links';

@Component({
    name: 'ResetPassword',
})
export default class ResetPassword extends Vue {
    @Action('account/fetchCompanyByUser') private fetchCompany;

    // Data
    private user: User = {} as User;
    private disabled: boolean = false;
    private passwordChanged: boolean = false;
    private errorMsg: string = '';
    private serverErrorMsg: string = '';
    private token: string = '';

    private mounted() {
        if (this.$route.query.hasOwnProperty('token')) {
            this.token = this.$route.query.token.toString();
        }
    }

    // Methods
    private resetPassword() {
        const self = this;
        self.errorMsg = '';
        self.serverErrorMsg = '';
        if (!this.user.password || this.user.password === '') {
            this.errorMsg = 'password';
            return 0;
        } else if (this.user.password.length < 8) {
            this.errorMsg = 'shortPassword';
            return 0;
        }

        self.disabled = true;

        userWebservice
            .resetPassword(this.token, this.user)
            .then((response) => {
                self.errorMsg = '';
                self.passwordChanged = true;

                goToNativeLink('auth/logout');
            })
            .catch((error) => {
                self.disabled = false;
                self.serverErrorMsg = self.$t('messages.AnErrorHasOccurredPleaseTryAgain').toString();
                console.log(error);
            });
    }

    private validateEmail(email: string) {
        /* tslint:disable-next-line:max-line-length */
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    }
}
